import { useState } from "react";
import { db } from "./firebase";
import {
  doc,
  updateDoc
} from "firebase/firestore";

function EditProperty({
  property,
  goBack,
  onUpdated
}) {

  const [propertyCategory, setPropertyCategory] =
    useState(property.propertyCategory);

  const [town, setTown] =
    useState(property.town);

  const [area, setArea] =
    useState(property.area);

  const [estate, setEstate] =
    useState(property.estate || "");

  const [plotName, setPlotName] =
    useState(property.plotName);

  const [houseType, setHouseType] =
    useState(property.houseType);

  const [rent, setRent] =
    useState(property.rent);

  const [contact, setContact] =
    useState(property.contact);

  const [email, setEmail] =
    useState(property.email || "");

  const [landlordName, setLandlordName] =
    useState(property.landlordName || "");

  const [saving, setSaving] =
    useState(false);

  const saveChanges = async () => {

    if (
      !propertyCategory ||
      !town ||
      !area ||
      !plotName ||
      !houseType ||
      !rent ||
      !contact ||
      !landlordName
    ) {
      alert("Please fill all required fields.");
      return;
    }

    try {

      setSaving(true);

      await updateDoc(
        doc(db, "houses", property.id),
        {
          propertyCategory,
          town,
          area,
          estate,
          plotName,
          houseType,
          rent: Number(rent),
          contact,
          landlordName,
          email
        }
      );

      alert("✅ Property updated successfully.");

      onUpdated();

    } catch (err) {

      alert(err.message);

    } finally {

      setSaving(false);

    }

  };

  return (

    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#000,#1a1a1a,#ffd600)",
        padding: "30px"
      }}
    >

      <button
        onClick={goBack}
        style={{
          background: "#ffd600",
          border: "none",
          padding: "12px 20px",
          borderRadius: "10px",
          fontWeight: "bold",
          cursor: "pointer",
          marginBottom: "20px"
        }}
      >
        ⬅ Back
      </button>

      <div
        style={{
          maxWidth: "700px",
          margin: "0 auto",
          background: "white",
          padding: "30px",
          borderRadius: "25px"
        }}
      >

        <h1>
          ✏️ Edit Property
        </h1>
        <select
          value={propertyCategory}
          onChange={(e) =>
            setPropertyCategory(e.target.value)
          }
          style={inputStyle}
        >
          <option value="">Select Category</option>
          <option>Residential</option>
          <option>Commercial</option>
        </select>

        <select
          value={town}
          onChange={(e) =>
            setTown(e.target.value)
          }
          style={inputStyle}
        >
          <option value="">Select Town</option>
          <option>Nairobi</option>
          <option>Mombasa</option>
          <option>Kisumu</option>
          <option>Nakuru</option>
          <option>Eldoret</option>
          <option>Machakos</option>
          <option>Kithimani-Yatta</option>
          <option>Kitui</option>
          <option>Thika</option>
          <option>Meru</option>
          <option>Nyeri</option>
        </select>

        <input
          placeholder="Area"
          value={area}
          onChange={(e) =>
            setArea(e.target.value)
          }
          style={inputStyle}
        />

        <input
          placeholder="Estate (Optional)"
          value={estate}
          onChange={(e) =>
            setEstate(e.target.value)
          }
          style={inputStyle}
        />

        <input
          placeholder="Plot Name"
          value={plotName}
          onChange={(e) =>
            setPlotName(e.target.value)
          }
          style={inputStyle}
        />

        <select
          value={houseType}
          onChange={(e) =>
            setHouseType(e.target.value)
          }
          style={inputStyle}
        >
          <option value="">
            Select House Type
          </option>

          {propertyCategory === "Residential" && (
            <>
              <option>Single Room</option>
              <option>Bedsitter</option>
              <option>Double Room</option>
              <option>1 Bedroom Apartment</option>
              <option>2 Bedroom Apartment</option>
              <option>3 Bedroom Apartment</option>
              <option>2 Bedroom Mansionette</option>
              <option>3 Bedroom Mansionette</option>
              <option>3 Bedroom Bungalow</option>
            </>
          )}

          {propertyCategory === "Commercial" && (
            <>
              <option>Office Space</option>
              <option>Shop</option>
              <option>Retail Space</option>
              <option>Warehouse</option>
              <option>Business Premises</option>
              <option>Commercial Building</option>
            </>
          )}
        </select>

        <input
          type="number"
          placeholder="Monthly Rent"
          value={rent}
          onChange={(e) =>
            setRent(e.target.value)
          }
          style={inputStyle}
        />

        <input
          placeholder="Contact Number"
          value={contact}
          onChange={(e) =>
            setContact(e.target.value)
          }
          style={inputStyle}
        />

        <input
          placeholder="Landlord Name"
          value={landlordName}
          onChange={(e) =>
            setLandlordName(e.target.value)
          }
          style={inputStyle}
        />

        <input
          type="email"
          placeholder="Email Address (Optional)"
          value={email}
          onChange={(e) =>
            setEmail(e.target.value)
          }
          style={inputStyle}
        />
        <div
          style={{
            display: "flex",
            gap: "15px",
            marginTop: "30px"
          }}
        >
          <button
            onClick={saveChanges}
            disabled={saving}
            style={{
              flex: 1,
              background: "#2e7d32",
              color: "white",
              border: "none",
              padding: "15px",
              borderRadius: "12px",
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "16px"
            }}
          >
            {saving
              ? "Saving..."
              : "💾 Save Changes"}
          </button>

          <button
            onClick={goBack}
            style={{
              flex: 1,
              background: "#d32f2f",
              color: "white",
              border: "none",
              padding: "15px",
              borderRadius: "12px",
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "16px"
            }}
          >
            ❌ Cancel
          </button>
        </div>

      </div>
    </div>
  );

}

const inputStyle = {
  width: "100%",
  padding: "13px",
  margin: "10px 0",
  borderRadius: "12px",
  border: "2px solid #ffd600",
  fontSize: "16px",
  boxSizing: "border-box",
  outline: "none"
};

export default EditProperty;